import useIsRegionalHubClouder from './useIsRegionalHubClouder';

const ORDERS_HOME_PATH = '/orders/dashboard';
const ROUTES_HOME_PATH = '/routes/dashboard';

export default function useClouderHomePath() {
  const { isRegionalHubClouder, isLoading } = useIsRegionalHubClouder();

  return {
    homePath: isRegionalHubClouder ? ORDERS_HOME_PATH : ROUTES_HOME_PATH,
    isLoading,
    isRegionalHubClouder,
  };
}

export { ORDERS_HOME_PATH, ROUTES_HOME_PATH };
